export default "__VITE_ASSET__a1983b0f__"